import React, {useState, useEffect, useContext} from "react";
import DashboardWidget from "./DashboardWidget";
import axios from "../common/axios";
import {BrandContext} from "../common/BrandContext";
import useCurrentShortcut from "../hooks/useCurrentShortcut";
import ListItemTodo from "../common/ListItemTodo";
import ButtonsGroup from "../common/ButtonsGroup";
import Button from "../common/Button";
import PopConfirm from "../common/PopConfirm";

const StudentToDoListDashboardWidget = props => {
    const {...other} = props;
    const todoTypes = {
        TEST: {type: 'TEST', label: 'Tests'},
        FOLLOWUP_WORK: {type: 'FOLLOWUP_WORK', label: 'Follow-up Work'},
        TRAIL: {type: 'TRAIL', label: 'Tasks'},
        COMPETITION: {type: 'COMPETITION', label: 'Competitions'}
    };
    const [isLoading, setLoading] = useState(false);
    const [todoType, setTodoType] = useState(todoTypes.TEST);
    const [todoList, setTodoList] = useState([]);
    const brandConfig = useContext(BrandContext);
    const {loadShortcutByUrl} = useCurrentShortcut();

    useEffect(() => {
        setLoading(true);
        if (todoType !== undefined) {
            axios.post('/web/ui/todo/userToDoListType', [todoType.type], {})
                .then(response => {
                    setTodoList(response.data);
                    setLoading(false);
                });
        } else {
            setLoading(false);
        }
    }, [todoType]);

    const handleClick = (todo) => {
        if(todo === undefined) {
            return;
        }

        if (todo.toDoType === todoTypes.TEST.type) {
            if(todo.url === '/controlCentre/startAdaptiveTest.action') {
                loadShortcutByUrl(todo.url, {testAssignmentId: todo.testAssignmentId});
            } else {
                loadShortcutByUrl(todo.url, undefined, todo.testAssignmentId);
            }
        } else if (todo.toDoType === todoTypes.FOLLOWUP_WORK.type) {
            loadShortcutByUrl(todo.url, {testAssignmentId: todo.testAssignmentId}, todo.testResultId);
        } else if (todo.toDoType === todoTypes.TRAIL.type) {
            loadShortcutByUrl(todo.url, {currentPathwayAssignmentId: todo.trailAssignmentId, startTrailFromDashboard: true});
        } else if (todo.toDoType === todoTypes.COMPETITION.type) {
            loadShortcutByUrl(todo.url, {competitionId: todo.competitionId, startCompetitionFromDashboard: true});
        }
    };

    return (
        <>
            {brandConfig.use2025Dashboard &&
                <h2>My to do list</h2>
            }
            <DashboardWidget
                title={
                    !brandConfig.use2025Dashboard &&
                    <div className="ch-dashboard-title-with-icon">
                        <svg className="ch-icon-medium" viewBox="0 0 128 128">
                            <use href="#tests-icon"></use>
                        </svg>
                        <span>My to do list</span>
                    </div>
                }
                isLoading={isLoading}
                {...other}>
                <ButtonsGroup className="margin-b--l">
                    <Button type={(todoType.type === todoTypes.TEST.type ? '' : 'outline')} onClick={()=>{setTodoType(todoTypes.TEST)}} >{brandConfig.testName}</Button>
                    {brandConfig.hasDiagnosticTests &&
                        <Button type={(todoType.type === todoTypes.FOLLOWUP_WORK.type ? '' : 'outline')} onClick={()=>{setTodoType(todoTypes.FOLLOWUP_WORK)}}>{brandConfig.diagnosticFeedbackName}</Button>
                    }
                    <Button type={(todoType.type === todoTypes.TRAIL.type ? '' : 'outline')} onClick={()=>{setTodoType(todoTypes.TRAIL)}} >{brandConfig.taskName}</Button>
                    {brandConfig.hasScorchers &&
                        <Button type={(todoType.type === todoTypes.COMPETITION.type ? '' : 'outline')} onClick={()=>{setTodoType(todoTypes.COMPETITION)}} >{brandConfig.competitionName}</Button>
                    }
                </ButtonsGroup>
                <div className={'ch-dashboard-blk-body'}>
                    {todoList.length > 0 &&
                        <table className={'ch-dashboard-widget-table ch-table'}>
                            <thead>
                                <tr>
                                    <th style={{width:'80%'}}>
                                        {todoType.type === todoTypes.TEST.type ?  brandConfig.testName + ' name' : ''}
                                        {todoType.type === todoTypes.FOLLOWUP_WORK.type ?  brandConfig.diagnosticFeedbackName : ''}
                                        {todoType.type === todoTypes.TRAIL.type ?  brandConfig.taskName + ' name' : ''}
                                        {todoType.type === todoTypes.COMPETITION.type ?  brandConfig.competitionName: ''}
                                    </th>
                                    {todoType.type === todoTypes.FOLLOWUP_WORK.type ?
                                        <>
                                            <th>Due</th>
                                            <th className={'ch-align-center'}>Skills</th>
                                        </> :
                                        <>
                                            <th>Assigned</th>
                                            <th>Expires</th>
                                        </>
                                    }
                                    <th className={'ch-align-center'}>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {todoList.map((todo, index) => (
                                    <React.Fragment key={index}>
                                        {(todoType.type == todoTypes.TEST.type && todo.testType == 'ASSESSMENT') ?
                                            <PopConfirm
                                                title={'You only get one attempt to answer all questions. Are you sure you want to start this ' + brandConfig.testName + '?'}
                                                okText={'Start ' + brandConfig.testName}
                                                cancelText="Cancel"
                                                onConfirm={()=>{handleClick(todo)}}
                                            >
                                                <ListItemTodo todo={todo}/>
                                            </PopConfirm> :
                                            <ListItemTodo todo={todo} onClick={()=>{handleClick(todo)}} />
                                        }
                                    </React.Fragment>
                                ))}
                            </tbody>
                        </table>
                    }
                    {todoList.length === 0 &&
                        <div className="ch-list-item-disabled ch-warning-text">
                            No {todoType.label} assigned
                        </div>
                    }
                </div>
            </DashboardWidget>
        </>
    )
}

export default StudentToDoListDashboardWidget;